module.exports = __webpack_public_path__ + "static/jurek.bb40e05c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jurek.jpg
// module id = 481
// module chunks = 263791100135453